module.exports = __webpack_public_path__ + "static/img/network-1.33b80ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/network/network-1.png
// module id = biVM
// module chunks = 1